import React, { useState, useEffect, useMemo } from 'react';
import { useLocation, history, useIntl } from 'umi';
import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import CheckIcon from '@material-ui/icons/Check';
import DoneIcon from '@material-ui/icons/Done';
import CloseIcon from '@material-ui/icons/Close';
import ClearIcon from '@material-ui/icons/Clear';
import DataTableNativeML from '@/components/DataTableNativeML';
import HeadCard from './components/headCard';
import DialogDataML from '@/components/DialogDataML/DialogDataML';
import request from '@/utils/request';
import webStorage from '@/utils/storageManager';
import SearchGroup from './components/search_group/SearchGroup';

export default () => {
  const intl = useIntl();
  const { formatMessage } = intl;
  const location = useLocation();
  const { query } = location;
  const { id, detail, date } = query;
  const genderObj = {
    F: '女',
    M: '男',
    U: '未知',
  };
  const vipList = [
    {
      label: '会员姓名',
      id: 'name',
    },
    {
      label: '性别',
      id: 'gender',
      render(key) {
        return genderObj[key];
      },
    },
    {
      label: '会员号',
      id: 'memberCode',
    },
    {
      label: '手机号',
      id: 'mobile',
    },
    {
      label: '会员等级',
      id: 'level',
    },
  ];

  const [vipTableData, setVipTableData] = useState([]);
  const [chooseTablesIds, setChooseTablesIds] = useState([]);
  const [openDialog, setOpenDialog] = useState(false);
  const [detailData, setDetailData] = useState(null);
  const [refresh, setRefresh] = useState();
  const DICTOBJ = webStorage.get('DICTOBJ');

  const [searchData, setSearchData] = useState('wechat');
  const columns = detail
    ? [
        {
          title: formatMessage({ id: 'cm.member.detail.c01.lbl02' }),
          align: 'center',
          id: 'storeName',
          key: 'storeName',
        },
        {
          title: formatMessage({ id: 'cm.member.detail.c01.lbl03' }),
          key: 'type',
          id: 'type',
          align: 'center',
          render: ({ type: recor }) => {
            let itemUnuse = {};
            itemUnuse = DICTOBJ.IDENTITY_TYPE.filter((item) => {
              return recor === item.dictCode;
            });
            return itemUnuse[0] && itemUnuse[0].nameZh;
          },
        },

        {
          title: formatMessage({ id: 'cm.member.detail.c01.lbl06' }),
          align: 'center',
          id: 'account',
          key: 'account',
        },
        {
          title: '解绑时间',
          align: 'center',
          id: 'createDate',
          key: 'createDate',
        },
      ]
    : [
        {
          type: 'checkbox',
          width: 80,
          onChange: (a, b, c) => {
            console.log({ c });
            setChooseTablesIds(c);
          },
        },
        {
          title: formatMessage({ id: 'cm.member.detail.c01.lbl02' }),
          align: 'center',
          id: 'storeName',
          key: 'storeName',
        },
        {
          title: formatMessage({ id: 'cm.member.detail.c01.lbl03' }),
          key: 'type',
          id: 'type',
          align: 'center',
          render: ({ type: recor }) => {
            let itemUnuse = {};
            itemUnuse = DICTOBJ.IDENTITY_TYPE.filter((item) => {
              return recor === item.dictCode;
            });
            return itemUnuse[0] && itemUnuse[0].nameZh;
          },
        },

        {
          title: formatMessage({ id: 'cm.member.detail.c01.lbl06' }),
          align: 'center',
          id: 'account',
          key: 'account',
        },
        {
          title: '绑定时间',
          align: 'center',
          id: 'bindDate',
          key: 'bindDate',
        },
      ];

  const initButton = () => {
    const buttonNode = (
      <div
        style={{
          display: 'flex',
          justifyContent: 'flex-end',
          gap: '0 16px',
          width: '100%',
          marginBottom: '24px',
          marginRight: '24px',
        }}
      >
        <Button
          sx={{
            width: '108px!important',
          }}
          variant="contained"
          color="secondary"
          startIcon={<ClearIcon sx={{ width: '20px', height: '20px' }} />}
          onClick={onCloseDialog}
        >
          取消
        </Button>
        <Button
          sx={{ width: '108px!important' }}
          variant="contained"
          startIcon={<CheckIcon sx={{ width: '20px', height: '20px' }} />}
          onClick={onSave}
        >
          确定
        </Button>
      </div>
    );
    return { buttonNode, isShow: true, height: 'auto' };
  };

  const handleClickRemoveBind = () => {
    console.log('chooseTablesIds', chooseTablesIds);
    setOpenDialog(true);
  };
  const onCloseDialog = () => {
    setOpenDialog(false);
  };
  const onSave = () => {
    // const data = chooseTablesIds.map((item) => ({
    //   type: item.type,
    //   store: item.store,
    //   account: item.account,
    //   channel: item.channel,
    // }));
    request('/manualOperation', {
      method: 'POST',
      data: {
        value: JSON.stringify(chooseTablesIds),
        memberCode: detailData.memberCode,
        memberId: detailData.id,
        mobile: detailData.mobile,
        type: 'UNBIND',
      },
    })
      .then(() => {
        window.message.toast({
          type: 'success',
          message: '解绑成功',
        });
        setChooseTablesIds([]);
        setRefresh(new Date().getTime());
      })
      .catch(() => {});
    setOpenDialog(false);
  };
  console.log({ chooseTablesIds });

  useEffect(() => {
    request('/member/queryMemberInfo', {
      method: 'POST',
      data: {
        id,
      },
    }).then((res) => {
      if (detail) {
        const detailInit = JSON.parse(detail)?.map((item) => ({
          ...item,
          createDate: date,
        }));
        setVipTableData(detailInit);
      } else {
        const filterData = res.data.identityList
          .filter((item) => {
            return (
              item.channel === 'PRIVATEPROGRAM' ||
              (item.channel !== 'PRIVATEPROGRAM' &&
                ['WECHAT_OPENID', 'WECHAT_UNIONID'].includes(item.type))
            );
          })
          .map((item, index) => ({
            ...item,
            id: index,
          }));
        setVipTableData(filterData);
      }

      setDetailData(res.data);
    });
  }, [refresh, detail]);
  const tableData = useMemo(() => {
    return (
      vipTableData?.filter((item) => {
        if (searchData === 'wechat') {
          return (
            item.channel !== 'PRIVATEPROGRAM' &&
            ['WECHAT_OPENID', 'WECHAT_UNIONID'].includes(item.type)
          );
        } else if (searchData === 'PRIVATEPROGRAM') {
          return item.channel === 'PRIVATEPROGRAM';
        }
        return !searchData;
      }) || []
    );
  }, [searchData, vipTableData]);
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '24px 0px' }}>
      <HeadCard data={detailData} list={vipList} />
      {detail ? '' : <SearchGroup setSearchData={setSearchData} />}
      <DataTableNativeML
        columns={columns}
        data={tableData || []}
        chooseIds={
          chooseTablesIds &&
          Array.isArray(chooseTablesIds) &&
          chooseTablesIds.length > 0
            ? chooseTablesIds.map((item) => item.account)
            : []
        }
        columnKey="account"
        // devicesMinWidth='100'
        np={true}
        pageButton={false}
      ></DataTableNativeML>
      <Box
        sx={{
          borderRadius: '12px',
          backgroundColor: '#fff',
          padding: '24px',
          display: 'flex',
          gap: '16px',
        }}
      >
        <Button
          variant="contained"
          color="secondary"
          className="exit"
          startIcon={<CloseIcon sx={{ width: '16px', height: '16px' }} />}
          onClick={() => {
            history.goBack();
          }}
        >
          退出
        </Button>
        {chooseTablesIds.length ? (
          <Button
            variant="contained"
            className="finish"
            startIcon={<DoneIcon sx={{ width: '16px', height: '16px' }} />}
            onClick={handleClickRemoveBind}
          >
            解绑
          </Button>
        ) : (
          ''
        )}
      </Box>
      <DialogDataML
        open={openDialog}
        title="确认解绑"
        content={<div style={{ width: '320px' }}>确定要解除绑定吗？</div>}
        handleClose={onCloseDialog}
        button={initButton()}
      ></DialogDataML>
    </div>
  );
};
